const faqList = document.querySelector('.js--element-faqList');

if (faqList) {
    faqList.addEventListener('click', e => {
        e.target.matches('dt') && e.target.classList.toggle('isOpen');
    });
}
